module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "SOM"
  }, [_c('div', {
    staticClass: "SOM_titre"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pre"
  }, [_c('a', {
    attrs: {
      "href": "#/pre2"
    }
  }, [_vm._v("General preface")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pre"
  }, [_c('a', {
    attrs: {
      "href": "#/pre3"
    }
  }, [_vm._v("Author’s preface")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pre"
  }, [_c('a', {
    attrs: {
      "href": "#/pre4"
    }
  }, [_vm._v("Chief abbreviations")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('a', {
    attrs: {
      "href": "#/pre4#niv1-001"
    }
  }, [_vm._v("Commentaries")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('a', {
    attrs: {
      "href": "#/pre4#niv1-002"
    }
  }, [_vm._v("Texts and versions")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pre"
  }, [_c('a', {
    attrs: {
      "href": "#/pre5"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('a', {
    attrs: {
      "href": "#/pre5#niv1-003"
    }
  }, [_vm._v("I. Title and contents")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('a', {
    attrs: {
      "href": "#/pre5#niv1-004"
    }
  }, [_vm._v("2. Structure")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('a', {
    attrs: {
      "href": "#/pre5#niv1-005"
    }
  }, [_vm._v("3. Sources")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('a', {
    attrs: {
      "href": "#/pre5#niv1-006"
    }
  }, [_vm._v("4. Date and authorship")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('a', {
    attrs: {
      "href": "#/pre5#niv1-007"
    }
  }, [_vm._v("5. The Hebrew text of Numbers")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('a', {
    attrs: {
      "href": "#/pre5#niv1-008"
    }
  }, [_vm._v("6. Problems of interpreting Numbers")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('a', {
    attrs: {
      "href": "#/pre5#niv2-001"
    }
  }, [_vm._v("a. The importance of ritual")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('a', {
    attrs: {
      "href": "#/pre5#niv2-002"
    }
  }, [_vm._v("b. The essence of ritual")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('a', {
    attrs: {
      "href": "#/pre5#niv2-003"
    }
  }, [_vm._v("c. The interpretation of ritual and symbol")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('a', {
    attrs: {
      "href": "#/pre5#niv2-004"
    }
  }, [_vm._v("d. An anthropologically based approach to ritual symbolism")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('a', {
    attrs: {
      "href": "#/pre5#niv1-009"
    }
  }, [_vm._v("7. The theology of Numbers")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('a', {
    attrs: {
      "href": "#/pre5#niv2-005"
    }
  }, [_vm._v("a. The character of God")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('a', {
    attrs: {
      "href": "#/pre5#niv2-006"
    }
  }, [_vm._v("b. The land")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('a', {
    attrs: {
      "href": "#/pre5#niv2-007"
    }
  }, [_vm._v("c. The people of God")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('a', {
    attrs: {
      "href": "#/pre5#niv1-010"
    }
  }, [_vm._v("8. The Christian use of Numbers")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pre"
  }, [_c('span', {
    attrs: {
      "href": "#/pre6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Analysis")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_part"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#part-001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Commentary")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#chap-001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1. The people of God prepare to enter the promised land (1: 1 – 10: 10 )")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv1-011",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A. Censuses (chapters 1 – 4)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv1-012",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Additional note on the large numbers")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv1-013",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Additional note on the history of the priests and Levites")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv1-014",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B. Cleansing the camp (chapters 5 – 6)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv1-015",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C. Offerings for the altar (chapter 7)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv1-016",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("D. Dedication of the Levites (chapter 8)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv1-017",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("E. The second passover (chapter 9)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap1#niv1-018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("F. The silver trumpets (10:1–10)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. From Sinai to Kadesh (10: 11 – 12: 16 )")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2#niv1-019",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A. Departure in battle order (10:11–36)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap2#niv1-020",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B. Three complaints (11:1 – 12:16)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. Forty years near Kadesh (13: 1 – 19: 22 )")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap3#niv1-021",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A. The rebellion of the spies (chapters 13 – 14)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap3#niv1-022",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Additional note on the sources in Numbers 13 – 14")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap3#niv1-023",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B. Laws on offerings (chapter 15)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap3#niv1-024",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C. Prerogatives of the priests (chapters 16 – 18)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap3#niv1-025",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Additional note on the source analysis of chapters 16 – 17")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap3#niv1-026",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("D. Laws on cleansing (chapter 19)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. From Kadesh to the plains of Moab (20: 1 – 22: 1)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. Israel in the plains of Moab (22: 2 – 36: 13 )")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv1-027",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A. Balaam and Balak (chapters 22 – 24)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv1-028",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B. National apostasy (chapter 25)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv1-029",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C. Census (chapter 26)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv1-030",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("D. Laws about land, offerings and vows (chapters 27 – 30)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv1-031",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Additional note on Old Testament sacrifice")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv2-008",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("a. Animal sacrifice")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv2-009",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("b. Other sacrifices")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv1-032",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("E. Defeat of Midian and settlement in Transjordan (chapters 31 – 32)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv1-033",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("F. List of camp sites (33:1–49)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv1-034",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Additional note on the route of the Israelites")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv2-010",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("a. From Goshen to the Red Sea (3–8)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv2-011",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("b. From the Red Sea to Sinai (8–15)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv2-012",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("c. From Sinai to Kadesh (16–36)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv2"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv2-013",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("d. From Kadesh To Moab (37–49)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_niv1"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5#niv1-035",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("G. Laws about land (33:50 – 36:13)")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Praise for Tyndale Commentaries")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/TOTC_TNTC",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tyndale Commentary Volumes")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("More Titles from InterVarsity Press")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pdf"
  }, [_c('span', {
    attrs: {
      "href": "#/ident12#copy1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright Page")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-029e4e6e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sommaire.vue
// module id = 63
// module chunks = 0